var _rect, _rect2, _rect3, _rect4, _circle, _path, _path2, _rect5, _rect6, _path3, _path4, _rect7, _rect8, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294,
    height: 200,
    viewBox: "0 0 294 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 294,
    height: 200,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 43.2983,
    width: 123.179,
    height: 48.8806,
    rx: 8.65854,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62.9258,
    y: 60.8955,
    width: 60.6119,
    height: 13.6866,
    rx: 6.84328,
    fill: "#A3BBD1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 107.821,
    width: 101.672,
    height: 48.8806,
    rx: 8.65854,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84.2684,
    cy: 132.546,
    r: 13.5223,
    fill: "#A3BBD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.1083 136.847L78.9801 133.719C78.6285 133.367 78.0606 133.367 77.709 133.719C77.3574 134.07 77.3574 134.638 77.709 134.99L81.4772 138.758C81.8288 139.11 82.3967 139.11 82.7483 138.758L92.286 129.22C92.6376 128.869 92.6376 128.301 92.286 127.949C91.9345 127.598 91.3665 127.598 91.0149 127.949L82.1083 136.847Z",
    fill: "#003A70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7697 60.2299H43.103C43.6895 60.2299 43.9763 59.526 43.5592 59.1219L39.9225 55.4982C39.6618 55.2506 39.2577 55.2506 38.997 55.4982L35.3733 59.1219C34.9562 59.526 35.243 60.2299 35.8295 60.2299H38.1628V73.2908H35.8295C35.243 73.2908 34.9562 73.9947 35.3733 74.3987L39.01 78.0224C39.2707 78.2701 39.6748 78.2701 39.9355 78.0224L43.5722 74.3987C43.9893 73.9947 43.6895 73.2908 43.116 73.2908H40.7697V60.2299Z",
    fill: "#003A70"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 135.27,
    y: 107.821,
    width: 142.731,
    height: 48.8806,
    rx: 8.65854,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 184.148,
    y: 125.418,
    width: 56.7015,
    height: 13.6866,
    rx: 6.84328,
    fill: "#A3BBD1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.391 141.256L148.138 141.986V130.215L144.97 137.854C144.436 139.183 145.074 140.708 146.391 141.256ZM171.809 136.433L165.344 120.83C164.94 119.853 163.988 119.253 162.984 119.227C162.645 119.227 162.293 119.279 161.955 119.423L152.348 123.398C151.37 123.802 150.771 124.741 150.745 125.744C150.732 126.096 150.797 126.448 150.94 126.787L157.405 142.39C157.809 143.381 158.774 143.98 159.791 143.993C160.13 143.993 160.469 143.928 160.794 143.798L170.388 139.822C171.718 139.275 172.356 137.75 171.809 136.433ZM153.365 127.048C152.648 127.048 152.061 126.461 152.061 125.744C152.061 125.028 152.648 124.441 153.365 124.441C154.082 124.441 154.668 125.028 154.668 125.744C154.668 126.461 154.082 127.048 153.365 127.048ZM150.758 141.386C150.758 142.82 151.931 143.993 153.365 143.993H155.255L150.758 133.122V141.386Z",
    fill: "#003A70"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M252.735 129.833C252.385 130.183 252.385 130.747 252.735 131.097L256.848 135.21C257.198 135.56 257.762 135.56 258.112 135.21L262.225 131.097C262.574 130.747 262.574 130.183 262.225 129.833C261.875 129.484 261.311 129.484 260.961 129.833L257.475 133.31L253.998 129.833C253.649 129.484 253.075 129.493 252.735 129.833Z",
    fill: "#003A70"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 154.82,
    y: 43.2983,
    width: 123.179,
    height: 48.8806,
    rx: 8.65854,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 203.703,
    y: 60.8955,
    width: 58.6567,
    height: 13.6866,
    rx: 6.84328,
    fill: "#A3BBD1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M184.817 68.0637L184.817 70.3969C184.817 70.9835 185.521 71.2702 185.925 70.8531L189.549 67.2164C189.796 66.9557 189.796 66.5516 189.549 66.2909L185.925 62.6672C185.521 62.2501 184.817 62.5369 184.817 63.1235L184.817 65.4567L171.756 65.4567L171.756 63.1235C171.756 62.5369 171.052 62.2501 170.648 62.6672L167.024 66.304C166.777 66.5647 166.777 66.9687 167.024 67.2294L170.648 70.8662C171.052 71.2833 171.756 70.9835 171.756 70.4099L171.756 68.0637L184.817 68.0637Z",
    fill: "#003A70"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.489 126.777H40.3644L38.1484 133.079H42.7049L40.489 126.777Z",
    fill: "#003A70"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4354 118.412C32.7905 118.412 26.5859 124.617 26.5859 132.262C26.5859 139.907 32.7905 146.111 40.4354 146.111C48.0804 146.111 54.2849 139.907 54.2849 132.262C54.2849 124.617 48.0804 118.412 40.4354 118.412ZM44.5903 138.369L43.51 135.295H37.3609L36.2667 138.369C36.1005 138.854 35.6297 139.186 35.1172 139.186C34.2586 139.186 33.663 138.328 33.9677 137.524L38.5935 125.226C38.8843 124.464 39.6045 123.952 40.4354 123.952C41.2526 123.952 41.9866 124.464 42.2774 125.226L46.9032 137.524C47.2078 138.328 46.6123 139.186 45.7537 139.186C45.2274 139.186 44.7565 138.854 44.5903 138.369Z",
    fill: "#003A70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2);
export default __webpack_public_path__ + "static/media/card2.7ab2a1de6a00b3a58b737f9c73deeb9d.svg";
export { ForwardRef as ReactComponent };